import { logError } from '@/lib/utils/shared/log'
import { useEffect, useRef } from 'react'

export const useSendEventOnLoad = ({ event }: { event: () => void }) => {
  const hasTriggered = useRef(false)

  useEffect(() => {
    if (typeof event !== 'function' || hasTriggered.current) {
      return
    }

    const timeoutId = setTimeout(() => {
      try {
        event()
        hasTriggered.current = true
      } catch (error) {
        logError('Error in useSendEventOnLoad:', error)
      }
    }, 500) // Increased delay for more reliability

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeoutId)
    }
  }, [event])
}
